import Link from 'next/link';
import { shortenAddress } from '../helpers/address';
import { ChartContainer } from './ActivityCharts';

export const OwnerStatsTable = ({ ownerStats = {} }) => {
  const { holderCountsByItemCount, holderList } = ownerStats;
  return (
    <div className='mt-3 gap-3 text-[16px] md:grid md:grid-cols-2 md:flex-nowrap'>
      <ChartContainer className='h-fit'>
        <table className=''>
          <thead>
            <tr>
              <td className='px-3 font-bold'>Token</td>
              <td className='px-3 font-bold'>Holders</td>
            </tr>
          </thead>
          <tbody>
            {holderCountsByItemCount &&
              holderCountsByItemCount.map((h, i) => (
                <tr key={h.orderKey + 'holtercntit' + i}>
                  <td className='px-3'>{h.between}</td>
                  <td className='px-3'>{h.count}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </ChartContainer>
      <ChartContainer className={'mt-3 md:mt-0'}>
        <table className=''>
          <thead>
            <tr>
              <td className='px-3 font-bold'>Rank</td>
              <td className='px-3 font-bold'>Wallet</td>
              <td className='px-3 font-bold'>Ownings</td>
              <td className='px-3 text-right font-bold'>% of Supply</td>
            </tr>
          </thead>
          <tbody>
            {holderList &&
              holderList.map((h, i) => (
                <tr key={h.owner + 'holtercntit' + i}>
                  <td className='px-3 font-bold'>#{i}</td>
                  <td className='px-3'>
                    <Link
                      href='#'
                      className='text-sm text-accent hover:text-accent-light dark:text-white'
                    >
                      {shortenAddress(h.owner)}
                    </Link>
                  </td>
                  <td className='px-3'>{h._count._all}</td>
                  <td className='flex min-w-[160px] px-3'>
                    <div className='relative mr-2 mt-2 h-[7px] w-[70px] bg-jacarta-200'>
                      <div
                        className={`absolute h-full bg-jacarta-700`}
                        style={{ width: `${h.percOfSupply}%` }}
                      />
                    </div>
                    % {parseFloat(h.percOfSupply).toFixed(2)}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </ChartContainer>
    </div>
  );
};
